import type { BaseSyntheticEvent } from 'react';

import { useDecisions } from '@libs/common-next';

import { useProduct } from '@/entities/product';
import { usePurchaseFormWatch } from '@/entities/purchase-form';
import { useAutoshipCustomerStatus } from '@/features/autoship-customer-status';

import { useAddToCartSubmit } from './useAddToCartSubmit';
import { useExistingAutoshipSubmit } from './useExistingAutoshipSubmit';

export const useSubmit = () => {
    const autoshipFlag = useDecisions('ff_autoship');

    const { product } = useProduct();
    const { isReady: isAutoshipCustomerStatusReady, isExistingAutoshipCustomer } = useAutoshipCustomerStatus();

    const { submitHandler: baseSubmit } = useAddToCartSubmit();
    const { submitHandler: existingAutoshipSubmit } = useExistingAutoshipSubmit();

    const purchaseOption = usePurchaseFormWatch('purchaseOption');
    const isAutoshipSelected = purchaseOption === 'autoship';

    const subscriptionType = usePurchaseFormWatch('subscriptionType');

    const isExistingType = autoshipFlag === 'crawl' ? subscriptionType === 'existing' : true;
    const isExistingAutoshipEnable =
        isExistingAutoshipCustomer && isAutoshipSelected && !product?.pharmacy && isExistingType;

    const selectedSubmit = isExistingAutoshipEnable ? existingAutoshipSubmit : baseSubmit;
    const submitHandler = async (event?: BaseSyntheticEvent) => {
        if (isAutoshipSelected && !isAutoshipCustomerStatusReady) {
            event?.preventDefault();
            return;
        }

        await selectedSubmit(event);
    };

    return { submitHandler };
};
